import { useParams  } from "react-router-dom";
import React from "react";
import PriceComparisonSelling from "../../../../containers/Print/default/Price-Comparison-Selling";
import PriceComparisonPurchasing from "../../../../containers/Print/default/Price-Comparison-Purchasing";
export const PrintPriceComparison = (props)=>{
    let params=useParams();
    let data=params;
    let type=params.type;
    document.getElementById("root").setAttribute("style","overflow:hidden");
    if(type == 'purchasing'){
        return (
            <PriceComparisonPurchasing  data={data}/>
        )
    }else if(type == 'selling'){
        return (
            <PriceComparisonSelling  data={data}/>
        )
    }
   
}

export default PrintPriceComparison;